import { act } from "react-dom/test-utils";
import * as types from "../Action/type";

const initialState = {
  loading: false,
  error: null,
  message: null,
  typing: false,
  stopTyping: false,
  userAction: null,
  LogOutUser: null,
  SUBADMIN_Roles: null,
  contact_us_count: null,
  talentCount: null,
  organizationCount: null,
  orderTalentCount: null,
  NewMessage: null,
  updatedUser: null,
};
const SocketReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_UPDATE_ROLE:
      return {
        ...state,
        updatedUser: action.payload,
      };
    case types.FETCH_Organization_COUNT:
      return {
        ...state,
        organizationCount: action.payload,
      };
    case types.FETCH_Order_Talent_COUNT:
      return {
        ...state,
        orderTalentCount: action.payload,
      };
    case types.FETCH_New_Message:
      return {
        ...state,
        NewMessage: action.payload,
      };
    case types.FETCH_CONTACT_US_COUNT:
      return {
        ...state,
        contact_us_count: action.payload,
      };
    case types.FETCH_TALENT_COUNT:
      return {
        ...state,
        talentCount: action.payload,
      };
    case types.FETCH_NEW_Message:
      return {
        ...state,
        message: action.payload,
      };

    case types.CLEAR_MESSAGE:
      return {
        ...state,
        message: null,
        NewMessage: null,
      };

    case types.FETCH_TYPING:
      return {
        ...state,
        typing: true,
        userAction: action.payload,
      };
    case types.FETCH_STOP_TYPING:
      return {
        ...state,
        typing: false,
        userAction: action.payload,
      };
    case types.FETCH_UNSEENMESSAGES_COUNT:
      return {
        ...state,
        UnseenMessagesCount: action.payload,
      };

    default:
      return state;
  }
};
export default SocketReducer;
